export default "__VITE_ASSET__UuY0ad0k__"